export enum EVENTS {
    FOCUS = "on-focus",
    BLUR = "on-blur",
    CLICK = "on-click",
    SUBMIT = "on-submit",
    CHANGE = "on-change",
    MOUSEOVER = "on-mouseover",
    MOUSEOUT = "on-mouseout",
    MOUSEDOWN = "on-mousedown",
    MOUSEUP = "on-mouseup",
    KEYDOWN = "on-keydown",
    KEYUP = "on-keyup"
}
